import { render, staticRenderFns } from "./PollDetail.vue?vue&type=template&id=7b904c22&scoped=true"
import script from "./PollDetail.vue?vue&type=script&lang=js"
export * from "./PollDetail.vue?vue&type=script&lang=js"
import style0 from "./PollDetail.vue?vue&type=style&index=0&id=7b904c22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b904c22",
  null
  
)

export default component.exports